import LayoutWithSidebar from "../components/LayoutWithSidebar";
import RegisterSideMenu from "../components/RegisterSideMenu";
import MainHeaderContainer from "../containers/MainHeaderContainer";
import RegisterPermitsCountsContainer from "../containers/RegisterPermitsCountsContainer";
import RegisterPermitIssueTrendContainer from "../containers/RegisterPermitIssueTrendContainer";
import PermitInProgressAvgDurationContainer from "../containers/PermitInProgressAvgDurationContainer";
import PermitExpiredAvgDurationContainer from "../containers/PermitExpiredAvgDurationContainer";
import PermitRequestApprovalStatsContainer from "../containers/PermitRequestApprovalStatsContainer";
import { Card, Grid, GridColumn, Segment } from "semantic-ui-react";

const RegisterDashboardPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return (
      <Grid>
        <Grid.Row>
          <GridColumn only="mobile">
            <RegisterSideMenu iconOnly={true}></RegisterSideMenu>
          </GridColumn>
          <GridColumn only="tablet computer">
            <RegisterSideMenu iconOnly={false}></RegisterSideMenu>
          </GridColumn>
        </Grid.Row>
      </Grid>
    );
  };

  const contentPanelContent = () => {
    return (
      <>
        <RegisterPermitsCountsContainer />
        <Segment basic>
          <RegisterPermitIssueTrendContainer />
        </Segment>
        <Segment basic>
          <Card.Group stackable doubling itemsPerRow={3}>
            <Card>
              <PermitRequestApprovalStatsContainer />
            </Card>
            <Card>
              <PermitInProgressAvgDurationContainer />
            </Card>
            <Card>
              <PermitExpiredAvgDurationContainer />
            </Card>
          </Card.Group>
        </Segment>
      </>
    );
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default RegisterDashboardPage;
